class PendoUtils {
  static setDataToLS(analytics) {
    const newItem = {
      analytics,
      timestamp: new Date().toISOString()
    };

    localStorage.setItem('sm-account-data', JSON.stringify(newItem));
  }

  static sendDataToPendo(data) {
    // This function creates visitors and accounts in Pendo
    // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> with values you use in your app
    // Please use Strings, Numbers, or Bools for value types.
    data['visitor']['screenWidth'] = window.innerWidth;
    data['visitor']['screenHeight'] = window.innerHeight;
    pendo.initialize(data);
  }

  static fetchAccountData() {
    fetch('/analytics_account_data')
      .then(FetchUtils.checkResponseStatus)
      .then(response => response.json())
      .then(data => {
        PendoUtils.setDataToLS(data);
        PendoUtils.sendDataToPendo(data);
      }).catch(err => FetchUtils.handleResponseError(err));
  }

  static initWithAccountData() {
    const accountDataStr = localStorage.getItem('sm-account-data');

    if (accountDataStr) {
      const accountData = JSON.parse(accountDataStr);
      const itemTime = new Date(accountData.timestamp);
      const diffHours = (new Date() - itemTime) / (1000 * 60 * 60);
      if (diffHours < 24) {
        PendoUtils.sendDataToPendo(accountData.analytics);
      } else {
        PendoUtils.fetchAccountData();
      }
    } else {
      PendoUtils.fetchAccountData();
    }
  }
}

export default PendoUtils;
